
$(document).ready(function () {
  console.log("READY");

 

  //set sticky height
  if($(".blog__item.nav > div")){
    //blog and article page
    const top_height = $("header").outerHeight();
    $(".blog__item.nav > div").css("top", top_height+"px");
  }

  UpdateCart();
  
  /* Desktop Nav Controls */
  $("a[data-dropdown]").on("click", function (e) {
    e.preventDefault();
    var dropdown_class = $(this).attr("data-dropdown");

    var dropdown = $(".dropdown." + dropdown_class);

    //to toggle already out dropdowns
    if (!dropdown.hasClass("in-view")) {
      $(".dropdown.in-view").removeClass("in-view");
    }
    if (!dropdown.hasClass("relative")) {
      $(".dropdown.relative").removeClass("relative");
    }

    $(".dropdowns").addClass("in-view");
    dropdown.toggleClass("in-view");
    dropdown.addClass("relative");
  });

  //hide the hider
  $(".dropdown").on("transitionend", function () {
    console.log("done!");

    //need to check if ANY dropdown has inview
    console.log($(".dropdown.in-view").length);
    //if non are out, remove overlay
    if ($(".dropdown.in-view").length == 0) {
      //only remove container if it is retracting
      $(".dropdowns").removeClass("in-view");
      $(this).removeClass("relative");
    }
  });

  //mobile drop down
  $(".mobile-drop__heading").on("click", function(e){
      e.preventDefault();
      $(this).siblings(".mobile-drop__drop").slideToggle();
  })

  $(".dropdown .close").on("click", function () {
    $(this).parents(".dropdown").removeClass("in-view");
  });

  //Home sliders
  $(".featured-collection:not(.product) .featured-collection__slider").flickity({
    // options
    cellAlign: "left",
    contain: true,
    watchCSS: true,
    freeScroll: true,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true
  });
  $(".featured-collection.product .featured-collection__slider").flickity({
    // options
    cellAlign: "left",
    contain: true,
    watchCSS: true,
    freeScroll: true,
    prevNextButtons: false,
    pageDots: false,
    imagesLoaded: true,
    on: {
      ready: function() {
        $(".featured-collection.product .featured-collection__slider .product-item").css("height", "100%");
      }
    }
  });

  $(".home-review__slider").flickity({
    // options
    cellAlign: "center",
    contain: true,
    //watchCSS: true,
    freeScroll: true,
    prevNextButtons: true,
    pageDots: false,
    on: {
      ready: function() {
        $(".home-review__slider .item").css("height", "100%");
      }
    }
  });

  const image_slider = $(".image-slider").flickity({
    // options
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: false,
  });

  const content_slider = $(".content-slider").flickity({
    // options
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    sync: ".image-slider",
  });

  //Set total of home-casestudy
  const total_slides = document.querySelectorAll(
    ".wish-slider .content-slider .item"
  ).length;
  $(".slider-controls .count .total").html(total_slides);

  //Custom arrows
  $(".wish-slider  .arrow-prev").on("click", function () {
    content_slider.flickity("previous", false, false);
  });
  $(".wish-slider  .arrow-next").on("click", function () {
    content_slider.flickity("next", false, false);
  });

  content_slider.on("change.flickity", function (event, index) {
    var current = $(".slider-controls .count .current");

    const current_index = parseInt(current.html());
    const non_zero = index + 1;

    if (non_zero != current_index) {
      current.html(non_zero);
    }
  });

  //FAQ from trio bundle
  $(".faq .top").on("click", function () {
    $(this).siblings(".body").slideToggle();
    $(this).toggleClass("open");
  });

  //Add to cart with ajax
  $(".product-item .atc, .product-item .btn--atc").on("click", function (e) {
    e.preventDefault();

    if (!$(this).hasClass("disabled")) {
      const parent_item = $(this).parents(".product-item");
      const variant_id = parent_item.attr("data-variant");

      //leave add to cart up?
      parent_item.addClass("adding");

      const items = {
        quantity: 1,
        id: variant_id,
      };

      $.ajax({
        url: "/cart/add.js",
        method: "post",
        data: items,
        dataType: "json",
        success: function (data) {
          console.log(data);
          console.log(data.item_count);
          parent_item.addClass("added");
          parent_item.find(".btn--atc").addClass("disabled");

          //increase cart count by one
          $(".cart-count").html(parseInt($(".cart-count").html()) + 1);

          if($(".cart-count").hasClass("hide")){
            $(".cart-count").removeClass("hide")
          }
        },
        error: function (data) {
          console.log("ERROR -------------");
        },
      });
    }
  });

  //SORT BY - https://gist.github.com/carolineschnapp/11352987
  Shopify.queryParams = {};
  if (location.search.length) {
    for (
      var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
      i < aCouples.length;
      i++
    ) {
      aKeyValue = aCouples[i].split("=");
      if (aKeyValue.length > 1) {
        Shopify.queryParams[
          decodeURIComponent(aKeyValue[0])
        ] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }
  $("#sort-by").bind("change", function () {
    console.log("changed");
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, "%20");
  });

  $("#filter").bind("change", function () {
    window.location.href = $(this).val() + location.search;
  });

  //product page
  var product_top_slider = $(".top-slider").flickity({
    pageDots: false,
    prevNextButtons: false,
    //draggable: false,
    imagesLoaded: true,
    cellAlign: "left",
    contain: true,
    draggable: true,
  });
  var product_bot_slider = $(".bottom-slider").flickity({
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    asNavFor: ".top-slider",
    imagesLoaded: true,
    cellAlign: "left",
    arrowShape: { 
      x0: 10,
      x1: 60, y1: 50,
      x2: 70, y2: 40,
      x3: 30
    }
  });

  /* Product Page 
  if($("[data-product-json]").length > 0){
    const product_json = JSON.parse($("[data-product-json]").html());
    console.log(product_json);
  }*/

  //changing selected variant
  $(".variants select").on("change", function () {
    var option_array = [];

    $(".variants select").each(function () {
      //create an option array for comparison
      option_array.push($(this).val());
    });

    //join to compare strings (over array)
    var option_string = option_array.join(" / ");
    var selected_product;

    //compare value vs individual options
    for (let i = 0; i < product_json.variants.length; i++) {
      if (product_json.variants[i].title == option_string) {
        selected_product = product_json.variants[i];
        break;
      }
    }

    console.log(selected_product);

    const selected_product_id = selected_product.id;

    $("#productSelect").val(selected_product_id);

    updateHistoryState(selected_product);

    if($("#rc_container").length == 0){
        //only change for non-subscribe products
        if (selected_product.compare_at_price && selected_product.compare_at_price > selected_product.price ) {
            //selected variant has compare at price
            if ($(".single.cost.hide").hasClass("hide")) {
              $(".single.cost.hide").removeClass("hide");
            }
            if(selected_product.compare_at_price != null){
              $(".cost .price").html(
                Shopify.formatMoney(
                  selected_product.compare_at_price,
                  money_format
                )
              );
            }
            
        } 
        else {
            //no compare price of current vaiant
            //also turns off subscribe price
            $(".single.cost").addClass("hide");
        }
    }
    
    /*
    $(".qty-container .control").on("click", function () {
      console.log("QTY");

      const qty_value = parseInt($("#Quantity").val());

      if ($(this).hasClass("up")) {
        $("#Quantity").val(qty_value + 1);
      } else {
        //dont allow it to go less than 0
        if (qty_value != 0) {
          $("#Quantity").val(qty_value - 1);
        }
      }
    });
    */


    if(selected_product.price != null){
      $(".cost .discount").html(
        Shopify.formatMoney(selected_product.price, money_format)
      );
    }

    const variant_image = selected_product.featured_image;

    //select variant image
    if (variant_image != null) {
      var image_id = variant_image.id;
      //select using flickity
      $(".top-slider").flickity(
        "selectCell",
        "[data-imageId='" + image_id + "']"
      );
      $(".bottom-slider").flickity(
        "selectCell",
        "[data-imageId='" + image_id + "']"
      );
    }

    //Currently Unavailable
    if (selected_product.inventory_quantity < 1 && selected_product.inventory_management != null) {
      disableATC();
    } else {
      enableATC();
    }

  });

  $('.about-steps .item a').on('click', function(e){
    e.preventDefault();
    const target = $(this).attr('href');

    console.log(target);
    scrollTo(target);

  })
  //Hide show delivery options
  $(document).on("change", "input[name='purchase_type']", function () {
    const type_value = $(this).val();
    //Hide/show delivery frequency
    if (type_value == "autodeliver") {
      $("#rc_autodeliver_options").slideDown();
    } else {
      $("#rc_autodeliver_options").slideUp();
    }
  });

  //Control hidden select
  $(document).on("change", ".freq-buttons input", function () {
    console.log("CHANGED");
    const value = $(this).attr("data-value");

    $("select[name='properties[shipping_interval_frequency]']").val(value);
  });

    
  //#region Account
  /**
   * Loads the Account Login
   */

    $('[href="#reset_password"]').click(function(e) {
      e.preventDefault();
      $('#reset_password').removeClass('hide');
      $('#customer_login').addClass('hide');
    });
    $('[href="#login"]').click(function(e) {
      e.preventDefault();
      $('#reset_password').addClass('hide');
      $('#customer_login').removeClass('hide');
    });
  
  /**
   * Loads the Account Details
   */
    $('.account_details-toggle').click(function() {
      $(this).toggleClass('active');
      $(this).prev('.account_details-inner').slideToggle(300);
    });
  
  /**
   * Loads the Account Addresses
   */
    $('[href="#new-address"]').click(function(e) {
      e.preventDefault();
      $('.addresses').addClass('hide');
      $('.edit-address').addClass('hide');
      $('.addresses-new').removeClass('hide');
    });
    $('.new-address-cancel').click(function() {
      $('.addresses').removeClass('hide');
      $('.addresses-new').addClass('hide');
    });

    $('.address-edit').click(function() {
      $('.addresses').addClass('hide');
      $('.edit-address').addClass('hide');
      $('#address_' + this.dataset.address).removeClass('hide');
    });
    $('.edit-address-cancel').click(function() {
      $('.addresses').removeClass('hide');
      $(this).closest('.edit-address').addClass('hide');
    });

  //#endregion Account

  //#region Cart
  function UpdateCart() {
    console.log("UPAGE CART");
    // Load items into cart
    
    /*
    $.getJSON('/cart.js', function(cart) {
      RenderCart(cart);
    });
    */
  
    /**
     * Re-renders the cart
     *
     * @param {Cart} cart - Cart object data
     */
    function RenderCart(cart) {
      $('.cart-count').text(cart.item_count);
      $('[data-cart-price]').text(Shopify.formatMoney(cart.total_price, Shopify.money_format));

      if(cart.item_count > 0) {
        $('.cart-count').removeClass('hide');
      } else {
        $('.cart-count').addClass('hide');
      }
  
  
      var template = $('#line-item_template').html();
      if(template) {
        var output = "";
        if(cart.items.length) {
          for(let i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            var item_template = _.template(template);
            output += item_template({
              key: item.key,
              quantity: item.quantity,
              url: item.url,
              title: item.title,
              price: Shopify.formatMoney(item.price, Shopify.money_format),
              line_price: Shopify.formatMoney(item.line_price, Shopify.money_format),
              image: item.featured_image.url
            });
          }
        } else {
          output = '<div class="cart_line-item">Your cart is empty.</div>';
        }
        $('.cart_items').html(output);
      }
  
      // Bind cart remove to AJAX
      $('.btn-remove').click(function(e) {
        e.preventDefault();
        var btn = this;
        var item = $(btn).closest('.cart_line-item');
        var line = $(item).data('key');
        var line_item = $('.cart_line-item[data-key="' + line + '"]');
        
        $(line_item).addClass('removing');
  
        $.post('/cart/change', {
          id: line,
          quantity: 0
        }, function(cart) {
          $(line_item).remove();
          RenderCart(cart);
        }, "json");
      });
  
      // Bind cart quantity to AJAX
      $('.cart-quantity').on('input change', function(e) {
        $.post('/cart/change', {
          id: this.dataset.key,
          quantity: this.value
        }, function(cart) {
          RenderCart(cart);
        }, "json");
      });
    }

    /* VIP Steps Sticky */
    if($('#shopify-section-vip-steps').length > 0){
      var header = $('header').outerHeight();
      var padding_top = $('.about-steps').css("padding-top");

      
      var top_string = "calc(" + header + "px - " + padding_top + ")"; //-10px for buffer

      console.log(top_string);

      $("#shopify-section-vip-steps").css("top", top_string);
    }
}
//#endregion Cart

  /* BLOG PAGES */

  //category thing
  $(".featured-heading").on('click', function(){
    if(window.matchMedia("(max-width:991px)").matches) {
      $(this).next(".feature-tab").slideToggle().toggleClass('active');
    }
  })
  $(".feature-list .feature-head ").on('click', function(){
    
    
    if(!$(this).siblings(".feature-content").hasClass('active')){
      $(".feature-content.active").removeClass('active').slideUp();
      $(this).siblings(".feature-content").slideDown();
      $(this).siblings(".feature-content").addClass('active');
      
    }else{
      $(".feature-content.active").removeClass('active').slideUp();
    }
    
  })
  

});

function disableATC() {
  $("#add-item-form .btn--atc").attr("disabled", "true");
  $("#add-item-form .btn--atc span").html("Out OF Stock");
}
function enableATC() {
  $("#add-item-form .btn--atc").attr("disabled", null);
  $("#add-item-form .btn--atc span").html("Buy Now");
}

/* About Steps Sticky */
if($('#shopify-section-about-steps')){
  var header = $('header').outerHeight();
  var heading = $('.about-steps__container .heading').outerHeight();
  var padding_top = $('.about-steps').css("padding-top");

  console.log(padding_top);

  var top_string = "calc(" + header + "px - " + heading + "px - " + padding_top + " - 10px)"; //-10px for buffer
  $("#shopify-section-about-steps").css("top", top_string);
}



//From GearBunch
/**
 * Updates the URL with a history of the selected variant
 *
 * @param {Variant} variant - The new variant
 */
function updateHistoryState(variant) {
  if (!history.replaceState || !variant) {
    return;
  }

  var newurl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    "?variant=" +
    variant.id;
  window.history.replaceState({ path: newurl }, "", newurl);
}



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler from https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

//Clicking on button goes to css selector
function scrollTo(selector, offset=0){
  $('html, body').animate({
    scrollTop: $(selector).offset().top - $('header').outerHeight() - offset
  }, 800);
}

function selectBlend(index, doScroll) {
  $('#show_on_blend_select').removeClass('hide');

  var choices = $('.blend-choice');
  var tabs = $('.blend-content');

  console.log(choices)

  $('.blend-choice.active').removeClass('active');
  $('.blend-content.active').removeClass('active');

  $(choices[index]).addClass('active');
  $(tabs[index]).addClass('active');

  if(doScroll) {
    scrollTo('.blends-content', 0);
  }
}
if($('[data-frequency]')){
  $('[data-frequency]').click(function() {
    var frequency = this.dataset.frequency;
    $('[data-frequency]').removeClass('active');
    $('[data-frequency=' + frequency + ']').addClass('active');
  });
}


function addItemToCart (variant_id, quantity, shipping_interval_frequency, has_free_gift) {
  var data = {
    "quantity": quantity,
    "id": variant_id,
    "properties[shipping_interval_frequency]": shipping_interval_frequency, 
    "properties[shipping_interval_unit_type]": "Days",            
    "properties[subscription_id]": "208626" 
  };
  // free mug
  // var datafree = { "quantity": 1, "id": 30312491221054 };
  // free grinder
  var datafree = { "quantity": 1, "id": 12135275135038 };
  
  $.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    success: function() {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
          if(has_free_gift) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: datafree,
              dataType: 'json',
              success: function() { 
                window.location = reChargeProcessCart();
              }
            });
          } else {
            //window.location = '/cart';
            window.location = reChargeProcessCart();
          }
        }
      });
    }
  });
}

function reChargeProcessCart() {
  return reChargeProcessCart('FIRST_MONTH_20');
}

function reChargeProcessCart(discount) {
	function get_cookie(name) { return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0 )[2]; }

	do { token = get_cookie('cart'); }
	while(token == undefined);

	var myshopify_domain='javapresse-coffee.myshopify.com';
	try {
    var ga_linker = ga.getAll()[0].get('linkerParam');
  } catch(err) {
    var ga_linker = '';
  }

  var customer_param = '';
  if(discount != ''){
    return checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker + "&discount=" + discount;
  }else{
    return checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
  }
	
}

$('.sales-form').submit(function(e){
  e.preventDefault();

  var form = this;

  if(!$('form input[type="submit"]').hasClass('disabled')){
    const product_id = $(form).find("[data-variant].active").data('variant');
    const freq = $(form).find("[data-frequency].active").data('frequency');
    const qty = $(form).find('input[name="qty"]').val();

    console.log("prod_id = " + product_id);
    console.log("freq = " + freq);
    console.log("qty = " + qty);

    $('form input[type="submit"]').addClass('disabled');

    addItemToCart(parseInt(product_id), qty, freq, $(form).hasClass('free-gift'));
  }
});

$('.single-form').submit(function(e){
  e.preventDefault();

  var form = this;

  if(!$('form input[type="submit"]').hasClass('disabled')){
    const product_id = $(form).find("[data-variant].active").data('variant');
    const qty = $(form).find('input[name="qty"]').val();

    console.log("prod_id = " + product_id);
    console.log("qty = " + qty);

    $('form input[type="submit"]').addClass('disabled');

    window.location.href = "/cart/" + product_id + ":" + qty;
  }
});

$('.sales-form input[name="qty"]').on('input', function() {
  var form = $(this).closest('.sales-form');
  var prices = $(form).find('[data-price]');
  for(var i = 0; i < prices.length; i++) {
    let price = prices[i];
    let base_price = price.dataset.price;
    let discount = price.dataset.discount != null ? parseFloat(price.dataset.discount) : 0;
    let final_price = Shopify.formatMoney((base_price * this.value * (1 - discount)), Shopify.money_format);
    $(price).text(final_price);
  }
});

$('.goto-single').click(function(e) {
  e.preventDefault();
  $('.blend-content.active .single-purchase').removeClass('hide');
  scrollTo('.blend-content.active .single-purchase', 0);
});


//SUBSCRIBE HEADER POPUP
$("body").on("click", ".header-sub-bg, [data-header-subscribe] .close", function(){
  //close embeded popup
  $("[data-header-subscribe]").css("display", "none");
})

$(".subscribe-extra").on("click", function(){
  //open embeded popup
  console.log("CLICKED");
  $("[data-header-subscribe]").css("display", "flex");
})
